import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="34" height="36" viewBox="0 0 34 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#C7BCE4"
      d="M21.5,0.9H5C3.8,0.9,2.9,1.8,2.9,3v30c0,1.2,0.9,2.1,2.1,2.1h24.1c1.2,0,2.1-0.9,2.1-2.1V10.2
	c0-0.6-0.2-1.1-0.7-1.5l-7.6-7.2C22.5,1.1,22,0.9,21.5,0.9z"
    />
    <path
      fill="#7876C1"
      d="M1.3,12.5h31.4c0.6,0,1,0.4,1,1v9.9c0,0.6-0.4,1-1,1H1.3c-0.6,0-1-0.4-1-1v-9.9C0.3,12.9,0.7,12.5,1.3,12.5z"
    />
    <g>
      <polygon
        fill="#ffffff"
        points="8.2,21.9 6.8,19.7 5.5,21.9 3.6,21.9 5.8,18.3 3.5,14.9 5.5,14.9 6.9,17 8.2,14.9 10.1,14.9 7.9,18.4 
		10.2,21.9 	"
      />
      <polygon
        fill="#ffffff"
        points="13.2,20.6 15.4,20.6 15.4,21.9 11.5,21.9 11.5,14.9 13.2,14.9 	"
      />
      <path
        fill="#ffffff"
        d="M19.2,22c-1.3,0-2.7-0.7-2.7-2.2h1.8c0,1,1.7,1.1,1.7,0.1c-0.1-0.7-0.7-0.7-1.3-1c-1.1-0.3-2.2-0.8-2.2-2.1
		c-0.1-2.8,5.2-2.8,5.2,0h-1.9c-0.1-1.4-2.4-0.5-1.2,0.4c0.8,0.5,2.3,0.6,2.8,1.5C22.4,20.3,20.9,22.1,19.2,22z"
      />
      <polygon
        fill="#ffffff"
        points="27.5,21.9 26,19.7 24.8,21.9 22.8,21.9 25.1,18.3 22.8,14.9 24.8,14.9 26.2,17 27.4,14.9 29.4,14.9 
		27.1,18.4 29.5,21.9 	"
      />
    </g>
  </svg>
);

const XlsxIcon = (props) => <Icon component={svg} {...props} />;

export default XlsxIcon;
